(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hally-harpersecret"] && !Shopify.designMode) return;
  try {
    

  document.querySelector('.hally-harpersecret__form .close-form').addEventListener('click', function() {
    $(document.querySelector('.hally-harpersecret__form')).fadeOut();
  });

document.querySelector('.harper-btn').addEventListener('click', function() {
    $(document.querySelector('.hally-harpersecret__form')).css('display','flex').hide();
    $(document.querySelector('.hally-harpersecret__form')).fadeIn();
    $(document.querySelector('.hally-harpersecret__form').querySelector('input[name="email"]')).focus();
  });

  document.addEventListener('DOMContentLoaded', function() {

    enquire.register('screen and (min-width: 768px)', {
      
      match: function() {
        $('.hally-harpersecret__media').each(function(i,v) {
          const $video = $(this).find('video');
          if($video.length) {
            $video_src = $video.find('source').data('src');
            $video.find('source').prop('src', $video_src);
            $video.load();
          }
        });
      }

    });

    enquire.register('screen and (max-width: 767px)', {

      match: function() {

        $('.hally-harpersecret__media').each(function(i,v) {
          const $video = $(this).find('video');
          if($video.length) {

            if($video.find('source').data('mobileSrc') !== undefined) {
              $video_src = $video.find('source').data('mobileSrc');
            } else {
              $video_src = $video.find('source').data('src');
            }

            $video.find('source').prop('src', $video_src);
            $video.load();
          }
        });
      }

    });

    const checkboxes = document.querySelectorAll('.handleCheckbox');

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (event) => {
        if(event.target.checked) {
          var data_target = event.target.dataset.target;
          $('input[name="' + data_target + '"]').slideDown().focus();
        } else {
          var data_target = event.target.dataset.target;
          $('input[name="' + data_target + '"]').val('');
          $('input[name="' + data_target + '"]').slideUp();
        }
      });
    });


    const radioCreator = document.querySelectorAll('input[name="radioCreator"]');

    radioCreator.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if(e.target.checked) {
          if(e.target.value == 'Yes') {
            $('.checkboxGroupCreator').slideDown();
          } else {
            $('.checkboxGroupCreator').slideUp();
            $('.input-handle').slideUp();
            checkboxes.forEach(checkbox => {
              checkbox.checked = false;
            });
          }
        }
      });
    });


  });



  function validateYear(input) {
    // 1. Check if the format is exactly 4 digits
    const yearRegex = /^\d{4}$/;
    if (!yearRegex.test(input)) {
      return false;
    }
  
    // 2. Convert to integer for range checking
    const year = parseInt(input, 10);
    const currentYear = new Date().getFullYear();
  
    // 3. Define your realistic range bounds
    const minYear = 1900;
    const maxYear = currentYear; 
  
    return year >= minYear && year <= maxYear;
  }


  document.getElementById('harpersecret-form').addEventListener('submit', async function(e) {
    e.preventDefault();
    
    const emailField = e.target.querySelector('input[name="email"]');
    const birthYearField = e.target.querySelector('input[name="birthYear"]');
    const creatorField = e.target.querySelector('input[name="radioCreator"]:checked');
    const tiktokField = e.target.querySelector('input[name="tiktokHandle"]');
    const youtubeField = e.target.querySelector('input[name="youtubeHandle"]');
    const instagramField = e.target.querySelector('input[name="instagramHandle"]');
    const submitButton = e.target.querySelector('button[type="submit"]');
    const formWrapper = e.target.closest('.hally-harpersecret__form-wrapper');
    const successMessage = e.target.closest('.hally-harpersecret__form').querySelector('.hally-harpersecret__form-success-message');

    if(!validateYear(birthYearField.value)) {
      alert('Please enter a valid year!');
      birthYearField.focus();
      return false;
    }

    // const messageDiv = document.getElementById('form-message');
    
    submitButton.classList.add('processing');
  
    // Configuration - Replace with your actual credentials
    const PUBLIC_API_KEY = 'VhXy3c'; 
    const LIST_ID = 'S7CWzN';
    const REVISION_DATE = '2026-07-15'; // Use the latest supported version
    
    // Formulate payload matching Klaviyo's JSON:API client schema
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "HarperSecretForm", // Helps track where signups came from
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: emailField.value,
                // To pass custom traits, add a properties object here:
                properties: { 
                  birth_year: birthYearField.value,
                  is_creator: creatorField.value,
                  tiktok_handle: tiktokField.value,
                  youtube_handle: youtubeField.value,
                  instagram_handle: instagramField.value
                }
              }
            }
          }
        },
        // The list_id MUST go here under relationships, NOT under attributes
        relationships: {
          list: {
            data: {
              type: "list",
              id: LIST_ID
            }
          }
        }
      }
    };
  
    try {
      // Note the public key is passed in the URL parameter 'company_id'
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=VhXy3c`, {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json', // Correct media type required by Klaviyo
          'revision': REVISION_DATE
        },
        body: JSON.stringify(payload)
      });
  
      if (response.ok) {
        $(formWrapper).fadeOut(400, function(){
          $(successMessage).fadeIn();
        });
        
        this.reset();
      } else {
        const errData = await response.json();
        console.error("Klaviyo Error Details:", errData);
        alert('Submission failed');
      }
    } catch (error) {
      console.error("Network error:", error);
      alert('Network error occured');
    } finally {
      submitButton.classList.remove('processing');
    }
  });



  } catch(e) { console.error(e); }
})();
})();
